import { addMonths, format } from 'date-fns';
import { Special } from '../../backend/db/all-entities';
import { CATEGORIES } from '../../misc-types/category';
import BusinessProfileHeader from '../business/profile-header';

export type CardRenderableSpecial = Pick<Special, 'category' | 'text' | 'month'> & {
  business: Pick<Special['business'], 'id' | 'name' | 'pricingPlan' | 'logoUrl'>;
};

interface Props {
  special: CardRenderableSpecial;
  showMonth?: boolean;
}

const SpecialCard: React.FC<Props> = ({ special, showMonth }) => (
  <div className='p-2 bg-gray-700 rounded'>
    <div>
      <span className='text-sm text-white bg-gray-500 rounded px-1 inline-block mr-1 align-baseline'>
        {CATEGORIES.find(c => c.slug === special.category)?.name ?? 'Nonexistent category'}
      </span>
      {showMonth && <>{format(addMonths(0, special.month), 'MMM yyyy')}&mdash;</>}
      {special.text}
    </div>
    <BusinessProfileHeader className='mt-1' business={special.business} />
  </div>
);

export default SpecialCard;
